import { z } from "zod"

import { isNumericString } from "./forms"

export const validateRequiredField = (
  value: string,
  fieldName: string,
  ctx: z.RefinementCtx,
  path: (string | number)[]
): boolean => {
  if (!value.trim()) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: `${fieldName} is required`,
      path,
    })
    return false
  }

  return true
}

export const validateNumericField = (
  value: string,
  fieldName: string,
  ctx: z.RefinementCtx,
  path: (string | number)[]
): boolean => {
  if (!isNumericString(value)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: `${fieldName} must be a number`,
      path,
    })
    return false
  }

  return true
}

export const validateValueInRange = (
  value: string,
  fieldName: string,
  min: number,
  max: number,
  ctx: z.RefinementCtx,
  path: (string | number)[]
): boolean => {
  const numericValue = Number(value)

  if (Number.isNaN(numericValue) || numericValue < min || numericValue > max) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: `${fieldName} must be between ${min} and ${max}`,
      path,
    })
    return false
  }

  return true
}

export const validateStringMaxLength = (
  value: string,
  fieldName: string,
  maxLength: number,
  ctx: z.RefinementCtx,
  path: (string | number)[]
): boolean => {
  if (value.length > maxLength) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: `${fieldName} must not exceed ${maxLength} characters`,
      path,
    })
    return false
  }

  return true
}
